import gql from 'graphql-tag';

export const GET_CAMPAIGNS_FOR_MERCHANT = gql`
  query getCampaignsForMerchant($params: CampaignsForMerchantInput!) {
    campaignsForMerchant(params: $params) {
      uuid
      name
    }
  }
`;

export default GET_CAMPAIGNS_FOR_MERCHANT;
